import * as React from "react"
import type { SVGProps } from "react"
const SvgPayment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.8 12.43a.7.7 0 0 1-.48-.2.7.7 0 0 1-.21-.5v-.2a3 3 0 0 1-1.23-.61 3 3 0 0 1-.81-.99.7.7 0 0 1 0-.62.8.8 0 0 1 .5-.43 1 1 0 0 1 .6 0q.3.1.52.41.25.34.58.52.34.18.61.18.54 0 .85-.25t.3-.57q0-.36-.35-.64A4 4 0 0 0 17.5 8a5 5 0 0 1-1.81-1 2 2 0 0 1-.56-1.46q0-.69.48-1.34t1.5-.88v-.18a.7.7 0 0 1 .2-.5.7.7 0 0 1 .48-.2q.3 0 .48.2a.7.7 0 0 1 .19.5v.18q.5.12.95.38t.73.68q.2.3.09.62a.8.8 0 0 1-.46.46 1 1 0 0 1-.55.01q-.3-.08-.66-.36a1 1 0 0 0-.36-.2 2 2 0 0 0-.44-.07q-.43 0-.69.18t-.25.44q0 .3.3.55.32.27 1.4.63 1.12.39 1.66.97.54.6.53 1.57 0 .89-.63 1.55a3 3 0 0 1-1.62.85v.15a.7.7 0 0 1-.2.5.6.6 0 0 1-.45.2m2.1 6.55-5.95 1.85L7 18.93v-5.5h1.6l5.85 2.15q.22.08.39.32a1 1 0 0 1 .16.53h-.27a14 14 0 0 1-1.47-.1 7 7 0 0 1-.96-.2l-1.05-.35a1 1 0 0 0-.76.06 1 1 0 0 0-.49.59 1 1 0 0 0 .05.77q.17.38.58.5l1.42.48q.42.15.83.2t1.07.05H19q.3 0 .54.16t.36.39m-12.9 2 6.43 1.8q.27.07.57.07t.57-.1l6.25-1.95q.6-.2.9-.5.27-.32.28-.87 0-1.35-.87-2.18a3 3 0 0 0-2.13-.82h-2a2.9 2.9 0 0 0-1.85-2.7l-5.88-2.18-.32-.08-.35-.04H3q-.83 0-1.41.59a2 2 0 0 0-.59 1.4v7q0 .84.59 1.42.58.6 1.41.59h2q.63 0 1.21-.4A2 2 0 0 0 7 20.98m-2-.55H3v-7h2z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgPayment
